import App from './App.svelte';
import styles from './main.css';

Math.clamp = (number, min, max) => {
	if (number < min) {
		return min;
	}
	if (number > max) {
		return max;
	}
	return number;
}

const app = new App({
	target: document.body
});

export default app;
